/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var PoSReportTemplateType;
(function (PoSReportTemplateType) {
    PoSReportTemplateType["SUBTOTAL_INCLUDING_TAX"] = "subtotal_including_tax";
    PoSReportTemplateType["SUBTOTAL_EXCLUDING_TAX"] = "subtotal_excluding_tax";
})(PoSReportTemplateType || (PoSReportTemplateType = {}));
